// extracted by mini-css-extract-plugin
export default {"loadPrevious":"loadPrevious_ipgQZ"};